import BaseRequest from './base/BaseRequest';

export default class CoinCheckRequest extends BaseRequest {

  getPriceBtcUsdExchanges() {
    const url = '/coin-check/btc-usd';
    return this.get(url);
  }
}
